export default __webpack_public_path__ + "static/media/loading.0636af91.gif";